import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, MapPin, SealCheck } from "@phosphor-icons/react";
import { VerticalIcon, VERTICAL_META, eur } from "@/lib/verticals";
import { Badge } from "@/components/ui/badge";

const ProviderCard = ({ p, index = 0 }) => {
  const navigate = useNavigate();
  return (
    <motion.button
      data-testid={`provider-card-${p.provider_id}`}
      onClick={() => navigate(`/provider/${p.provider_id}`)}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: index * 0.05 }}
      whileHover={{ y: -4 }}
      className="text-left bg-card rounded-2xl border border-border/70 overflow-hidden hover:border-primary/50 hover:shadow-lg transition-[border-color,box-shadow,transform] group"
    >
      <div className="relative h-40 overflow-hidden">
        <img src={p.cover_image} alt={p.business_name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        <Badge className="absolute top-3 left-3 bg-white/90 text-foreground hover:bg-white gap-1">
          <VerticalIcon v={p.vertical} size={13} weight="bold" />
          {VERTICAL_META[p.vertical]?.label}
        </Badge>
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading font-semibold text-base leading-tight flex items-center gap-1">
            {p.business_name}
            {p.verified && <SealCheck weight="fill" className="text-primary shrink-0" size={15} />}
          </h3>
        </div>
        <div className="flex items-center gap-1 text-sm text-muted-foreground mt-1">
          <MapPin size={14} /> {p.city}
        </div>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-center gap-1 text-sm font-medium">
            <Star weight="fill" className="text-amber-400" size={15} />
            {p.rating > 0 ? p.rating : "Nuovo"}
            {p.review_count > 0 && <span className="text-muted-foreground font-normal">({p.review_count})</span>}
          </div>
          <span className="text-sm text-muted-foreground">da <b className="text-foreground">{eur(p.min_price || 0)}</b></span>
        </div>
      </div>
    </motion.button>
  );
};

export default ProviderCard;
